module.exports = __webpack_public_path__ + "img/nothing.43c13964.png";